import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class About extends Component {
    render() {
        return (<section>
            <div className="container">
            <div className="row align-items-center justify-content-between" id="about-us">
            <div className="col-12 col-lg-4  mb-6 mb-lg-0">
                        <img src={require(`../../assets/images/about/selfie-prob.svg`)} alt="Image" className="img-fluid"/>
                    </div>
                    <div className="col-12 col-lg-8 col-xl-5">
                    <h2 className="mt-3">Advanced Face Matching</h2>
                    <p className="lead">Our AI-powered face verification technology compares live selfies against ID photos with industry-leading accuracy. Multiple verification models ensure the highest confidence scores for critical decisions.</p>
                        </div>
                </div>
            <div className="row align-items-center justify-content-between mt-5" id="about-us">

                <div className="col-12 col-lg-8 col-xl-5">
                    <h2 className="mt-3">Intelligent Anti-Spoofing</h2>
                    <p className="lead">Advanced liveness detection prevents fraud by identifying printed photos, screen displays, masks, and other spoofing attempts. Our multi-layered approach combines AI models with sophisticated heuristics for unmatched security.</p>
                </div>
                <div className="col-12 col-lg-4  mb-6 mb-lg-0">
                        <img src={require(`../../assets/images/about/anti-spoof.svg`)} alt="Image" className="img-fluid"/>
                </div>
            </div>
            <div className="row align-items-center justify-content-between" id="about-us">
            <div className="col-12 col-lg-4  mb-6 mb-lg-0">
                        <img src={require(`../../assets/images/about/doc-ver.svg`)} alt="Image" className="img-fluid"/>
                    </div>
                    <div className="col-12 col-lg-8 col-xl-5">
                    <h2 className="mt-3">Document Authenticity Verification</h2>
                    <p className="lead">Multi-layer detection system identifies photocopies, color copies, and printed documents with high accuracy. Our texture, reflectance, and color analysis ensures only genuine documents are accepted.</p>
                        </div>
                </div>
                <div className="row align-items-center justify-content-between mt-5" id="about-us">

               <div className="col-12 col-lg-8 col-xl-5">
                   <h2 className="mt-3">Seamless Integration</h2>
                   <p className="lead">Simple RESTful API designed for developers. Integrate identity verification into your applications in minutes with comprehensive documentation and dedicated support.</p>
               </div>
               <div className="col-12 col-lg-4  mb-6 mb-lg-0">
                       <img src={require(`../../assets/images/about/api.svg`)} alt="Image" className="img-fluid"/>
               </div>
           </div>
                {/* <div className="row align-items-center justify-content-between" id="about-us">
                    <div className="col-12 col-lg-4  mb-6 mb-lg-0">
                        <img src={require(`../../assets/images/about/03.png`)} alt="Image" className="img-fluid"/>
                    </div>
                    <div className="col-12 col-lg-8 col-xl-5">
                        <div> <span className="badge badge-primary-soft p-2">
                                <i className="la la-exclamation ic-3x rotation"/>
                            </span>
                            <h2 className="mt-3">We are a digital transformation agency</h2>
                            <p className="lead">We don't just build software, we build better businesses. We provide
                                tailored solutions that solve your unique challenges, unmatched proficiency in all
                                things code, clear roadmaps to guide your digital journey and seamless execution and
                                unwavering support.</p>
                        </div>
                        <div className="d-flex flex-wrap justify-content-start">
                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                <div className="d-flex align-items-center">
                                    <div className="badge-primary-soft rounded p-1">
                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none"
                                             stroke="currentColor" strokeWidth={2} strokeLinecap="round"
                                             strokeLinejoin="round" className="feather feather-check">
                                            <polyline points="20 6 9 17 4 12"/>
                                        </svg>
                                    </div>
                                    <p className="mb-0 ml-3">Custom Software Development</p>
                                </div>
                            </div>
                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                <div className="d-flex align-items-center">
                                    <div className="badge-primary-soft rounded p-1">
                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none"
                                             stroke="currentColor" strokeWidth={2} strokeLinecap="round"
                                             strokeLinejoin="round" className="feather feather-check">
                                            <polyline points="20 6 9 17 4 12"/>
                                        </svg>
                                    </div>
                                    <p className="mb-0 ml-3">Software Engineering Expertise</p>
                                </div>
                            </div>
                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                <div className="d-flex align-items-center">
                                    <div className="badge-primary-soft rounded p-1">
                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none"
                                             stroke="currentColor" strokeWidth={2} strokeLinecap="round"
                                             strokeLinejoin="round" className="feather feather-check">
                                            <polyline points="20 6 9 17 4 12"/>
                                        </svg>
                                    </div>
                                    <p className="mb-0 ml-3">Digital Transformation Strategy</p>
                                </div>
                            </div>
                            <div className="mb-3 mr-4 ml-lg-0 mr-lg-4">
                                <div className="d-flex align-items-center">
                                    <div className="badge-primary-soft rounded p-1">
                                        <svg width={20} height={20} viewBox="0 0 24 24" fill="none"
                                             stroke="currentColor" strokeWidth={2} strokeLinecap="round"
                                             strokeLinejoin="round" className="feather feather-check">
                                            <polyline points="20 6 9 17 4 12"/>
                                        </svg>
                                    </div>
                                    <p className="mb-0 ml-3">Project Management as a Service</p>
                                </div>
                            </div>
                        </div>
                        <Link to="/" className="btn btn-outline-primary mt-5">
                            Learn More
                        </Link>
                    </div>
                </div> */}
            </div>
        </section>);
    }
}

export default About;
